import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/pages"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function ViewStore (){
  const {user} = useUser()
  let view = contentLayout[modules.StoreList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.StoreList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.StoreList}></Index>
 )
}

export default ViewStore